import { lazy } from 'react';
import Template from '../../../core/templates/baseApp';
import LogoTemplate from '../../../core/templates/logo';

const OnBoardingPage = lazy(() => import('../pages'));
const CompleteRegistrationPage = lazy(
  () => import('../pages/CompleteRegistration')
);
const ThankYouScreenPage = lazy(() => import('../pages/ThankYouScreen'));
const TourSchedule = lazy(() => import('../pages/TourSchedule'));

export const OnboardingRoutes = [
  {
    path: '',
    element: (
      <Template>
        <OnBoardingPage />
      </Template>
    ),
  },
  {
    path: '/onboarding/completar-cadastro',
    element: (
      <LogoTemplate>
        <CompleteRegistrationPage />
      </LogoTemplate>
    ),
  },
  {
    path: '/onboarding/tour-guiado',
    element: (
      <Template>
        <TourSchedule />
      </Template>
    ),
  },
  {
    path: '/onboarding/obrigado',
    element: (
      <LogoTemplate>
        <ThankYouScreenPage />
      </LogoTemplate>
    ),
  },
];
